import * as Sentry from "@sentry/react";
import { Capacitor } from '@capacitor/core';
import { i18n } from "@lingui/core";
import { I18nProvider } from '@lingui/react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initateLingui } from './locales/InitTranslation';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { PushService } from './services/Utils/PushService';

// Sentry 초기화 - 오류 추적 및 성능 모니터링
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // 성능 모니터링 샘플 비율 (개발: 100%, 프로덕션에서는 0.1~0.2 권장)
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.2,
  // 세션 리플레이 (프로덕션에서만 활성화)
  replaysSessionSampleRate: import.meta.env.DEV ? 0 : 0.1,
  replaysOnErrorSampleRate: 1.0,
  // 환경 설정
  environment: import.meta.env.DEV ? 'development' : 'production',
  // 불필요한 노이즈성 오류 무시 (브라우저 내부 문제만)
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
  ],
});

const container = document.getElementById('root');
const root = createRoot(container!);

initateLingui().then(() => {
  root.render(
    // <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
    //  </React.StrictMode>
  );
});

if (Capacitor.getPlatform() === 'ios') {
  document.body.className = 'ios-mode';
}

// PushService.init()은 로그인 완료 후 FireClientAuth에서 호출됨

// serviceWorkerRegistration.unregister();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// serviceWorkerRegistration.register();
serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister(); // Unregister because this is caching the old version of the app.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
